import { IconFn, IconSvg } from "../createIcon";

export const MoonIcon: IconFn = ({ color = "#5C5C5C", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 20, height: 20 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 9c0-4.908 4.278-9 8.68-9a1 1 0 0 1 .894 1.447 8.12 8.12 0 0 0-.776 2.968c-.07 1.256.211 2.54 1.23 3.558 1.017 1.018 2.301 1.298 3.556 1.229a8.12 8.12 0 0 0 2.969-.776 1 1 0 0 1 1.447.894c0 4.402-4.093 8.676-9 8.68-4.968 0-9-4.032-9-9Zm7.155-6.78C4.926 3.005 2.5 5.773 2.5 9c0 3.863 3.136 7 7 7 3.228-.003 5.996-2.427 6.779-5.155a9.798 9.798 0 0 1-2.084.353c-1.624.09-3.54-.269-5.082-1.81C7.57 7.844 7.21 5.928 7.302 4.304c.041-.755.18-1.466.353-2.084Z"
      fill={color}
    />
  </IconSvg>
);
